import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { AllowOnlNumeric, GetOrdinal } from "../../../Helpers/Utilities";
import ErrorField from "../../../Components/ErrorField";
import DatePickerComponent from "../../../Components/DatePickerComponent";
import {
  CommonError_Msgs,
  NDMMTreatmentCohort_Msgs,
} from "../../../Helpers/HelperText";
import { NDMMCohortAgent, NDMMPhasesId } from "../../../Helpers/Enums";

const DoseFrequencyModificationTable = ({
  title,
  treatmentName,
  ndmmPhasesId,
  ndmmTreatmentCohortDetails,
  treatmentRow,
  listKey,
  UpdateTreatmentDoseFrequencyList,
}) => {
  const [treatmentList, setTreatmentList] = useState([]);

  useEffect(() => {
    if (ndmmTreatmentCohortDetails?.[listKey]) {
      setTreatmentList(ndmmTreatmentCohortDetails[listKey]);
    }
  }, [ndmmTreatmentCohortDetails, listKey]);

  const HandleRepeaterFieldChange = (e, index, fieldName, radioValue) => {
    const { value } = e.target;
    const parsedValue = value === "" ? "" : Number(value);
    let updatedListCopy = [];
    setTreatmentList((prevList) => {
      updatedListCopy = [...prevList];

      const updatedRow = {
        ...updatedListCopy[index],
        [fieldName]: parsedValue,
      };

      HandleDoseFrequencySideEffects(fieldName, radioValue, updatedRow);

      updatedListCopy[index] = updatedRow;

      return updatedListCopy;
    });

    UpdateTreatmentDoseFrequencyList(listKey, updatedListCopy);
  };

  const HandleDoseFrequencySideEffects = (
    fieldName,
    radioValue,
    updatedRow,
  ) => {
    const resetErrors = (...keys) => {
      keys.forEach((k) => (updatedRow[k] = false));
    };

    switch (fieldName) {
      case "doseFrequencyReceived":
        updatedRow.doseFrequencyReceivedDate = "";

        resetErrors(
          "bortezomibDoseFreqEmptyError",
          "bortezomibDoseFreqDateEmptyError",
          "bortezomibDoseFreqDateInvalidError",
          "bortezomibDoseFreqDateOFBError",
        );
        break;

      case "doseFrequencyBeforeUnit":
        updatedRow.doseFrequencyReceivedBefore = radioValue;

        resetErrors(
          "bortezomibDoseFreqBeforeEmptyError",
          "bortezomibDoseFreqBeforeUnitEmptyError",
          "bortezomibDoseFreqBeforeRangeError",
          "bortezomibDoseFreqAfterUnitSameError",
          "bortezomibDoseFreqBeforeUnitSameError",
        );
        break;

      case "doseFrequencyAfterUnit":
        updatedRow.doseFrequencyReceivedAfter = radioValue;

        resetErrors(
          "bortezomibDoseFreqAfterEmptyError",
          "bortezomibDoseFreqAfterWeekEmptyError",
          "bortezomibDoseFreqAfterRangeError",
          "bortezomibDoseFreqAfterUnitSameError",
          "bortezomibDoseFreqBeforeUnitSameError",
        );
        break;

      case "doseFrequencyReceivedBefore":
        updatedRow.doseFrequencyBeforeUnit = null;

        resetErrors(
          "bortezomibDoseFreqBeforeEmptyError",
          "bortezomibDoseFreqBeforeUnitEmptyError",
          "bortezomibDoseFreqBeforeRangeError",
          "bortezomibDoseFreqAfterUnitSameError",
          "bortezomibDoseFreqBeforeUnitSameError",
        );
        break;

      case "doseFrequencyReceivedAfter":
        updatedRow.doseFrequencyAfterUnit = null;

        resetErrors(
          "bortezomibDoseFreqAfterEmptyError",
          "bortezomibDoseFreqAfterWeekEmptyError",
          "bortezomibDoseFreqAfterRangeError",
          "bortezomibDoseFreqAfterUnitSameError",
          "bortezomibDoseFreqBeforeUnitSameError",
        );
        break;

      default:
        break;
    }
  };

  // Handle date change
  const HandleDateChange = (ctrlId, date, index) => {
    if (isNaN(index)) return;

    setTreatmentList((prevList) => {
      const updatedList = [...prevList];
      const row = updatedList[index];

      if (!row) return prevList;

      updatedList[index] = {
        ...row,
        doseFrequencyReceivedDate: date,
        doseFrequencyReceived: 2,
        bortezomibDoseFreqEmptyError: false,
        bortezomibDoseFreqDateEmptyError: false,
        bortezomibDoseFreqDateInvalidError: false,
        bortezomibDoseFreqDateOFBError: false,
      };

      UpdateTreatmentDoseFrequencyList(listKey, updatedList);
      return updatedList;
    });
  };

  const HandleAddRow = () => {
    if (!treatmentRow) return;
    setTreatmentList((prevList) => {
      const updatedList = [
        ...prevList,
        { ...treatmentRow, ndmmPhasesId: ndmmPhasesId },
      ];
      UpdateTreatmentDoseFrequencyList(listKey, updatedList);
      return updatedList;
    });
  };

  const HandleDeleteDoseFrequencyRow = (rowIndex) => {
    if (!Number.isInteger(rowIndex) || rowIndex < 0) return;

    setTreatmentList((prevList) => {
      const updatedList = prevList.filter((_, i) => i !== rowIndex);
      UpdateTreatmentDoseFrequencyList(listKey, updatedList);
      return updatedList;
    });
  };

  return (
    <div className="question-bot-sapce">
      <div className="question question-weight">
        <span>{title?.code}</span>
        <span className="quest-text-pad">{title?.text}</span>
      </div>

      <div className="dependent-section">
        {treatmentList?.length > 0 &&
          treatmentList.map((data, idx) => (
            <div className="loop-section-ul" key={idx}>
              <div className="loop-head">
                <span
                  className="question-weight"
                  style={{ float: "inline-start" }}
                >
                  {GetOrdinal(idx + 1)} bortezomib dose frequency
                  modification
                </span>
                {idx !== 0 && (
                  <div
                    className="delete-btn-div"
                    style={{
                      float: "inline-end",
                    }}
                  >
                    <img
                      width="16px"
                      src="../Assets/images/Icon-material-delete.png"
                      alt=""
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => HandleDeleteDoseFrequencyRow(idx)}
                    />
                  </div>
                )}
              </div>

              {/* Table */}
              <div className="question-bot-sapce">
                <div className="sub-question grid-overflow">
                  <table
                    style={{
                      border: "1px solid black",
                      borderCollapse: "collapse",
                      width: "100%",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          Date of bortezomib dose frequency modification
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "center",
                            minWidth: "320px",
                          }}
                        >
                          Dose frequency <i><u>before</u></i> modification
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "center",
                            minWidth: "320px",
                          }}
                        >
                          Dose frequency <i><u>after</u></i> modification
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "start",
                          }}
                        >
                          <div>
                            <div
                              className="option-without-input"
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                            >
                              <label className="option-fbox">
                                <input
                                  type="radio"
                                  style={{ marginTop: "6px" }}
                                  id={`doseFrequencyReceived-${ndmmPhasesId}-${idx}`}
                                  name={`doseFrequencyReceived-${ndmmPhasesId}-${idx}`}
                                  value={1}
                                  checked={data.doseFrequencyReceived === 1}
                                  onChange={(e) =>
                                    HandleRepeaterFieldChange(
                                      e,
                                      idx,
                                      "doseFrequencyReceived",
                                      null,
                                    )
                                  }
                                />

                                <span style={{ paddingLeft: "10px" }}>
                                  No bortezomib dose frequency modification
                                  occurred
                                </span>
                              </label>
                            </div>
                            <div
                              className="option-without-input"
                              style={{ display: "flex" }}
                            >
                              <input
                                type="radio"
                                id={`doseFrequencyReceived-${ndmmPhasesId}-${idx}`}
                                name={`doseFrequencyReceived-${ndmmPhasesId}-${idx}`}
                                value={2}
                                checked={data.doseFrequencyReceived === 2}
                                onChange={(e) =>
                                  HandleRepeaterFieldChange(
                                    e,
                                    idx,
                                    "doseFrequencyReceived",
                                    null,
                                  )
                                }
                              />

                              <span className="radio-text-padding">
                                <DatePickerComponent
                                  ctrlId={`doseFrequencyReceivedDate-${ndmmPhasesId}-${idx}`}
                                  HandleDateChange={(name, date) =>
                                    HandleDateChange(name, date, idx)
                                  }
                                  minDate={dayjs("01-01-1920")}
                                  maxDate={dayjs()}
                                  locale="en"
                                  date={data.doseFrequencyReceivedDate}
                                />
                              </span>
                            </div>
                            <div
                              className="option-without-input"
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                            >
                              <label className="option-fbox">
                                <input
                                  type="radio"
                                  style={{ marginTop: "6px" }}
                                  id={`doseFrequencyReceived-${ndmmPhasesId}-${idx}`}
                                  name={`doseFrequencyReceived-${ndmmPhasesId}-${idx}`}
                                  value={99}
                                  checked={data.doseFrequencyReceived === 99}
                                  onChange={(e) =>
                                    HandleRepeaterFieldChange(
                                      e,
                                      idx,
                                      "doseFrequencyReceived",
                                      null,
                                    )
                                  }
                                />

                                <span style={{ paddingLeft: "10px" }}>
                                  Date of modification unknown
                                </span>
                              </label>
                            </div>
                            <ErrorField
                              show={data.bortezomibDoseFreqEmptyError}
                              message={
                                NDMMTreatmentCohort_Msgs.radioOptionError
                              }
                              style={{
                                paddingLeft: "0px",
                              }}
                            />
                            <ErrorField
                              show={data.bortezomibDoseFreqDateEmptyError}
                              message={
                                NDMMTreatmentCohort_Msgs.bortezomibDateError
                              }
                              style={{
                                paddingLeft: "0px",
                              }}
                            />
                            <ErrorField
                              show={data.bortezomibDoseFreqDateInvalidError}
                              message={CommonError_Msgs.InvalidDate}
                              style={{
                                paddingLeft: "0px",
                              }}
                            />
                            <ErrorField
                              show={data.bortezomibDoseFreqDateOFBError}
                              message={
                                ndmmPhasesId === NDMMPhasesId.InductionTherapy
                                  ? NDMMTreatmentCohort_Msgs.q22ADateOutOfBondError
                                  : ndmmPhasesId ===
                                      NDMMPhasesId.ConsolidationTherapy
                                    ? NDMMTreatmentCohort_Msgs.q23ADateOutOfBondError
                                    : NDMMTreatmentCohort_Msgs.q24ADateOutOfBondError
                              }
                              style={{
                                paddingLeft: "0px",
                              }}
                            />
                          </div>
                        </td>

                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "start",
                          }}
                        >
                          <div>
                            <div>
                              <div
                                className="option-without-input"
                                style={{
                                  display: "flex",
                                }}
                              >
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    value={1}
                                    checked={
                                      data.doseFrequencyReceivedBefore === 1
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedBefore",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <input
                                      className="input-dash-sm"
                                      id={`doseFrequencyBeforeUnit-${ndmmPhasesId}-${idx}`}
                                      name={`doseFrequencyBeforeUnit-${ndmmPhasesId}-${idx}`}
                                      value={
                                        data.doseFrequencyReceivedBefore === 1
                                          ? (data.doseFrequencyBeforeUnit ?? "")
                                          : ""
                                      }
                                      style={{
                                        width: "50px",
                                        margin: "0 5px",
                                      }}
                                      onChange={(e) =>
                                        HandleRepeaterFieldChange(
                                          e,
                                          idx,
                                          "doseFrequencyBeforeUnit",
                                          1,
                                        )
                                      }
                                      maxLength={10}
                                      onKeyDown={AllowOnlNumeric}
                                    />
                                    times per week
                                  </span>
                                </label>
                              </div>
                              <div
                                className="option-without-input"
                                style={{
                                  display: "flex",
                                }}
                              >
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    value={2}
                                    checked={
                                      data.doseFrequencyReceivedBefore === 2
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedBefore",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    Once every
                                    <input
                                      className="input-dash-sm"
                                      id={`doseFrequencyBeforeUnit-${ndmmPhasesId}-${idx}`}
                                      name={`doseFrequencyBeforeUnit-${ndmmPhasesId}-${idx}`}
                                      value={
                                        data.doseFrequencyReceivedBefore === 2
                                          ? (data.doseFrequencyBeforeUnit ?? "")
                                          : ""
                                      }
                                      type="text"
                                      style={{
                                        width: "50px",
                                        margin: "0 5px",
                                      }}
                                      onChange={(e) =>
                                        HandleRepeaterFieldChange(
                                          e,
                                          idx,
                                          "doseFrequencyBeforeUnit",
                                          2,
                                        )
                                      }
                                      maxLength={10}
                                      onKeyDown={AllowOnlNumeric}
                                    />
                                    week(s)
                                  </span>
                                </label>
                              </div>
                              <div
                                className="option-without-input"
                                style={{
                                  display: "flex",
                                }}
                              >
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    value={3}
                                    checked={
                                      data.doseFrequencyReceivedBefore === 3
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedBefore",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    Other, please specify dosing schedule:{" "}
                                    <input
                                      className="input-dash-sm"
                                      id={`doseFrequencyBeforeUnit-${ndmmPhasesId}-${idx}`}
                                      name={`doseFrequencyBeforeUnit-${ndmmPhasesId}-${idx}`}
                                      value={
                                        data.doseFrequencyReceivedBefore === 3
                                          ? (data.doseFrequencyBeforeUnit ?? "")
                                          : ""
                                      }
                                      doseFrequencyReceivedBefore
                                      type="text"
                                      style={{
                                        width: "50px",
                                        margin: "0 5px",
                                      }}
                                      onChange={(e) =>
                                        HandleRepeaterFieldChange(
                                          e,
                                          idx,
                                          "doseFrequencyBeforeUnit",
                                          3,
                                        )
                                      }
                                      maxLength={10}
                                      onKeyDown={AllowOnlNumeric}
                                    />
                                  </span>
                                </label>
                              </div>
                              <div className="option-without-input">
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedBefore-${ndmmPhasesId}-${idx}`}
                                    value={99}
                                    checked={
                                      data.doseFrequencyReceivedBefore === 99
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedBefore",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    Unknown
                                  </span>
                                </label>
                              </div>
                              <ErrorField
                                show={data.bortezomibDoseFreqBeforeEmptyError}
                                message={
                                  NDMMTreatmentCohort_Msgs.radioOptionError
                                }
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                              <ErrorField
                                show={
                                  data.bortezomibDoseFreqBeforeUnitEmptyError
                                }
                                message={
                                  NDMMTreatmentCohort_Msgs.bortezomibDoseFrequencyBeforeError
                                }
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                              <ErrorField
                                show={data.bortezomibDoseFreqBeforeRangeError}
                                message={
                                  NDMMTreatmentCohort_Msgs.bortezomibRangeError
                                }
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                              <ErrorField
                                show={
                                  data.bortezomibDoseFreqBeforeUnitSameError
                                }
                                message={NDMMTreatmentCohort_Msgs.SameUnitError}
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                            </div>
                          </div>
                        </td>

                        <td
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            textAlign: "start",
                          }}
                        >
                          <div>
                            <div>
                              <div
                                className="option-without-input"
                                style={{
                                  display: "flex",
                                }}
                              >
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    value={1}
                                    checked={
                                      data.doseFrequencyReceivedAfter === 1
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedAfter",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <input
                                      className="input-dash-sm"
                                      id={`doseFrequencyAfterUnit-${ndmmPhasesId}-${idx}`}
                                      name={`doseFrequencyAfterUnit-${ndmmPhasesId}-${idx}`}
                                      value={
                                        data.doseFrequencyReceivedAfter === 1
                                          ? (data.doseFrequencyAfterUnit ?? "")
                                          : ""
                                      }
                                      type="text"
                                      style={{
                                        width: "50px",
                                        margin: "0 5px",
                                      }}
                                      onChange={(e) =>
                                        HandleRepeaterFieldChange(
                                          e,
                                          idx,
                                          "doseFrequencyAfterUnit",
                                          1,
                                        )
                                      }
                                      maxLength={10}
                                      onKeyDown={AllowOnlNumeric}
                                    />
                                    times per week
                                  </span>
                                </label>
                              </div>
                              <div
                                className="option-without-input"
                                style={{
                                  display: "flex",
                                }}
                              >
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    value={2}
                                    checked={
                                      data.doseFrequencyReceivedAfter === 2
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedAfter",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    Once every
                                    <input
                                      className="input-dash-sm"
                                      id={`doseFrequencyAfterUnit-${ndmmPhasesId}-${idx}`}
                                      name={`doseFrequencyAfterUnit-${ndmmPhasesId}-${idx}`}
                                      value={
                                        data.doseFrequencyReceivedAfter === 2
                                          ? (data.doseFrequencyAfterUnit ?? "")
                                          : ""
                                      }
                                      type="text"
                                      style={{
                                        width: "50px",
                                        margin: "0 5px",
                                      }}
                                      onChange={(e) =>
                                        HandleRepeaterFieldChange(
                                          e,
                                          idx,
                                          "doseFrequencyAfterUnit",
                                          2,
                                        )
                                      }
                                      maxLength={10}
                                      onKeyDown={AllowOnlNumeric}
                                    />
                                    week(s)
                                  </span>
                                </label>
                              </div>
                              <div
                                className="option-without-input"
                                style={{
                                  display: "flex",
                                }}
                              >
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    value={3}
                                    checked={
                                      data.doseFrequencyReceivedAfter === 3
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedAfter",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    Other, please specify dosing schedule:{" "}
                                    <input
                                      className="input-dash-sm"
                                      id={`doseFrequencyAfterUnit-${ndmmPhasesId}-${idx}`}
                                      name={`doseFrequencyAfterUnit-${ndmmPhasesId}-${idx}`}
                                      value={
                                        data.doseFrequencyReceivedAfter === 3
                                          ? (data.doseFrequencyAfterUnit ?? "")
                                          : ""
                                      }
                                      type="text"
                                      maxLength={10}
                                      style={{
                                        width: "50px",
                                        margin: "0 5px",
                                      }}
                                      onChange={(e) =>
                                        HandleRepeaterFieldChange(
                                          e,
                                          idx,
                                          "doseFrequencyAfterUnit",
                                          3,
                                        )
                                      }
                                      onKeyDown={AllowOnlNumeric}
                                    />
                                  </span>
                                </label>
                              </div>
                              <div className="option-without-input">
                                <label className="option-fbox">
                                  <input
                                    type="radio"
                                    id={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    name={`doseFrequencyReceivedAfter-${ndmmPhasesId}-${idx}`}
                                    value={99}
                                    checked={
                                      data.doseFrequencyReceivedAfter === 99
                                    }
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        idx,
                                        "doseFrequencyReceivedAfter",
                                        null,
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    Unknown
                                  </span>
                                </label>
                              </div>
                              <ErrorField
                                show={data.bortezomibDoseFreqAfterEmptyError}
                                message={
                                  NDMMTreatmentCohort_Msgs.radioOptionError
                                }
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                              <ErrorField
                                show={
                                  data.bortezomibDoseFreqAfterWeekEmptyError
                                }
                                message={
                                  NDMMTreatmentCohort_Msgs.bortezomibDoseFrequencyAfterError
                                }
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                              <ErrorField
                                show={data.bortezomibDoseFreqAfterRangeError}
                                message={
                                  NDMMTreatmentCohort_Msgs.bortezomibRangeError
                                }
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                              <ErrorField
                                show={data.bortezomibDoseFreqAfterUnitSameError}
                                message={NDMMTreatmentCohort_Msgs.SameUnitError}
                                style={{
                                  paddingLeft: "0px",
                                }}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ))}

        {/* Add Button */}
        {treatmentList?.length > 0 && treatmentList?.length < 550 && (
          <div className="sub-question-bot-sapce-ul mt-2">
            <div className="answer-list-text" onClick={HandleAddRow}>
              <a>
                <img width="18px" src="../Assets/images/plus.png" alt="" />
              </a>

              <a className="radio-text-padding">
                Click here to add another bortezomib dose frequency
                modification
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DoseFrequencyModificationTable;
